import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { Articulo, ArticuloResp } from '../models/articulo.model';
import { EMPTY, finalize, Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs';

import { SectorResp, Sector } from '../models/sector.model';
import { Seccion, SeccionResp } from '../models/seccion.model';
import { Familia, FamiliaResp } from '../models/familia.model';
import { ArtFiltroResp, ArtFiltro } from '../models/art-filtro.model';

import { AuthService } from './auth.service';
import { Usuario } from '../models/usuario.model';
import { StorageService } from './storage.service';
import { isPlatformBrowser } from '@angular/common';
import { NoopAnimationDriver } from '@angular/animations/browser';

@Injectable({
    providedIn: 'root'
})
export class ArticuloService {

    private SERVER_URL = environment.SERVER_ART_URL;
    // SERVER_AUTH deprecated - se usa Bearer token desde localStorage
    private SERVER_IMG = environment.SERVER_IMG;
    private SERVER_EAN_URL = environment.SERVER_EAN_URL;

    private articuloResp$!: ArticuloResp;
    public parametros!: Parametro;
    public paramUltBusca!: Parametro;
    public paramUltSeccion!: Parametro;
    public paramUltFamilia!: Parametro;
    public estado = 'init';
    public ordenar: Orden[] = [
        { valor: 'DA', descripcion: 'Descripción A-Z' },
        { valor: 'DD', descripcion: 'Descripción Z-A' },
        { valor: 'PD', descripcion: 'Precio de mayor a menor' },
        { valor: 'PA', descripcion: 'Precio de menor a mayor' },
        { valor: 'OA', descripcion: 'Por oferta' },
    ];
    public orden: Orden = this.ordenar[0];
    public articulo: Articulo | undefined;
    public articulos: Articulo[] = [];
    public articulosTop: Articulo[] = [];
    public articulosConsumo: Articulo[] = [];
    public articulosNovedad: Articulo[] = [];
    public articulosOferta: Articulo[] = [];
    public articulosDestac1: Articulo[] = [];
    public articulosDestac2: Articulo[] = [];
    public articulosDestac3: Articulo[] = [];
    public articulosDestac4: Articulo[] = [];
    public articulosDestac5: Articulo[] = [];
    public articulosDestac6: Articulo[] = [];
    // public lanzaConsulta: boolean = true;
    // tslint:disable-next-line:variable-name
    private _sectorActivo: Sector | undefined;
    sectores: Sector[] = [];
    // tslint:disable-next-line:variable-name
    private _seccionActivo: Seccion | undefined;
    secciones: Seccion[] = [];
    private _familiaActivo: Familia | undefined;
    familias: Familia[] = [];
    public gridList = true;

    response: any;
    artFiltroResp: ArtFiltroResp | undefined;
    artFiltros: ArtFiltro[] = [];

    /* Información alimentaria*/
    // Información general
    denominacionAlimento: string = "";
    nombreOperador: string = "";
    cantNeta: string = "";
    // Ingredientes y alérgenos
    ingredientes: string = "";
    alergenos: string = "";
    // Información Nutricional
    valorEnergetico: string = "";
    energia: string = "";
    grasas: string = "";
    saturadas: string = "";
    hidratosCarbono: string = "";
    azucares: string = "";
    fibraAlimentaria: string = "";
    proteinas: string = "";
    isArticuloDetalle: boolean = false;
    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private storageService: StorageService,
        private http: HttpClient,
        private authService: AuthService) {
        // if (authService.isLoggedIn()) {
        this.reseteaParametros();
        // }
    }
    public consultaArticulos() {
        if (this.sectorActivo && environment.AGRUPACION.toUpperCase() === 'SECTOR') {
            this.getSecciones();
        } else if (this.seccionActivo && environment.AGRUPACION.toUpperCase() === 'SECCION') {
            this.getFamilias();
        } else {
            this.getArticulos();
        }
    }
    public reseteaParametros() {
        this.estado = 'init';
        this.parametros = this.nuevoParametro();
        this.paramUltBusca = this.nuevoParametro();
        this.paramUltSeccion = this.nuevoParametro();
    }
    public reseteaSector() {
        this.sectorActivo = undefined;
        this.seccionActivo = undefined;
        this.familiaActivo = undefined;
    }
    set sectorActivo(sector: Sector | undefined) {
        this._sectorActivo = sector;
        this._seccionActivo = undefined;
        this.parametros.sec_id = '';
        if (sector !== undefined) {
            this.parametros.sector_id = String(this._sectorActivo!.sector_id);
        } else {
            this.parametros.sector_id = '';
        }
        this.getArticulos();
        this.getSecciones();
    }

    get sectorActivo(): Sector | undefined {
        return this._sectorActivo;
    }

    set seccionActivo(seccion: Seccion | undefined) {
        this._seccionActivo = seccion;
        this._familiaActivo = undefined;
        this.parametros.fam_id = '';
        if (seccion !== undefined) {
            this.parametros.sec_id = String(this._seccionActivo!.sec_id);
        } else {
            this.parametros.sec_id = '';
        }
        this.getArticulos();
        this.getFamilias();
    }

    get seccionActivo(): Seccion | undefined {
        return this._seccionActivo;
    }

    set familiaActivo(familia: Familia | undefined) {
        this._familiaActivo = familia;
        if (familia !== undefined) {
            this.parametros.fam_id = String(this._familiaActivo!.fam_id);
        } else {
            this.parametros.fam_id = '';
        }
        this.getArticulos();
    }

    get familiaActivo(): Familia | undefined {
        return this._familiaActivo;
    }

    getPedidoArticulos(): Observable<ArticuloResp> {
        const param: Parametro = this.nuevoParametro();
        param.alm_id = this.parametros.alm_id;
        param.pedcc_id = this.parametros.pedcc_id;
        param.cli_id = this.parametros.cli_id;
        param.espedido = true;
        param.limit = '100';

        return this.articulosHttpGet(param);
    }

    getListaArticulos(): Observable<ArticuloResp> {
        const param: Parametro = this.nuevoParametro();
        param.alm_id = this.parametros.alm_id;
        param.pedcc_lista_id = this.parametros.pedcc_lista_id;
        param.cli_id = this.parametros.cli_id;
        param.eslista = true;
        param.limit = '100';

        return this.articulosHttpGet(param);
    }

    getNovedadesArticulos(): Observable<ArticuloResp> {
        const param: Parametro = this.nuevoParametro();
        param.novedad = true;
        param.limit = '8';

        const articuloResp$ = this.articulosHttpGet(param);

        return articuloResp$ ? articuloResp$.pipe(
            tap(res => this.articulosNovedad.push(...res.items ?? [])), // Se usa spread para evitar map innecesario
            catchError(err => {
                this.handleError(err, false);
                return EMPTY;
            })
        ) : EMPTY;
    }


    getTopArticulos(): void {
        const param: Parametro = this.nuevoParametro();
        param.top30 = true;
        param.limit = '8';

        const articuloResp$ = this.articulosHttpGet(param);

        if (articuloResp$) {
            articuloResp$.subscribe({
                next: (res: ArticuloResp) => {
                    this.articulosTop.push(...(res.items ?? [])); // Añade los artículos si existen
                },
                error: (err) => {
                    this.handleError(err, true);
                }
            });
        }
    }


    getOfertaArticulos(): void {
        const param: Parametro = this.nuevoParametro();
        param.oferta = true;
        param.limit = '8';

        const articuloResp$ = this.articulosHttpGet(param);

        if (articuloResp$) {
            articuloResp$.subscribe({
                next: (res: ArticuloResp) => {
                    this.articulosOferta.push(...(res.items ?? []));
                },
                error: (err) => {
                    this.handleError(err, false);
                }
            });
        }
    }

    getConsumoArticulos(): void {
        const param: Parametro = this.nuevoParametro();
        param.oferta = true; // Asumo que esto está bien, aunque "consumo" y "oferta" no siempre van juntos
        param.limit = '8';

        const articuloResp$ = this.articulosHttpGet(param);

        if (articuloResp$) {
            articuloResp$.subscribe({
                next: (res: ArticuloResp) => {
                    this.articulosConsumo.push(...(res.items ?? []));
                },
                error: (err) => {
                    this.handleError(err, false);
                }
            });
        }
    }


    getArticulos(): void {
        const estoyLogeado = this.authService.isLoggedIn();
        if (!estoyLogeado && !environment.VER_PROD_LOGOUT) {
            return;
        }

        if (this.estado === 'cargando') {
            return;
        }
        if (!this.validarBusca(this.parametros.busca))
            this.parametros.busca = "";
        if (this.cambioConsulta(this.paramUltBusca) || this.estado === 'init') {
            this.salvaParametros(this.paramUltBusca);
            this.articulos = [];
            this.parametros.offset = '0';
        } else if (this.articuloResp$?.hasMore && !this.cambioConsulta(this.paramUltBusca)) {
            this.parametros.offset = String(this.articuloResp$.offset);
        } else {
            this.estado = 'cargado';
            return;
        }

        this.estado = 'cargando';

        const articuloResp$ = this.articulosHttpGet(this.parametros);

        articuloResp$.subscribe({
            next: (res: ArticuloResp) => {
                this.articuloResp$ = res;
                this.articulos.push(...(res.items ?? []));

                // Ver si hay que lanzar consulta secciones
                if (
                    this.sectorActivo !== null &&
                    this.seccionActivo === undefined &&
                    this.cambioConsulta(this.paramUltSeccion)
                ) {
                    this.getSecciones();
                }
            },
            error: (err) => {
                this.handleError(err, false);
                this.estado = 'cargado'; // Aseguramos que estado se actualiza también en error
            },
            complete: () => {
                this.estado = 'cargado';
            }
        });
    }



    getArticulosByDestacados(destacado: string): void {
        let paramDestacados: Parametro = this.nuevoParametro();

        // Inicialización de artículos según el destacado
        switch (destacado) {
            case '1':
                paramDestacados.destac_1 = 'S';
                this.articulosDestac1 = [];
                break;
            case '2':
                paramDestacados.destac_2 = 'S';
                this.articulosDestac2 = [];
                break;
            case '3':
                paramDestacados.destac_3 = 'S';
                this.articulosDestac3 = [];
                break;
            case '4':
                paramDestacados.destac_4 = 'S';
                this.articulosDestac4 = [];
                break;
            case '5':
                paramDestacados.destac_5 = 'S';
                this.articulosDestac5 = [];
                break;
            case '6':
                paramDestacados.destac_6 = 'S';
                this.articulosDestac6 = [];
                break;
            default:
                console.warn(`Destacado "${destacado}" no reconocido.`);
                return;
        }

        paramDestacados.limit = '8';

        const articuloResp$ = this.articulosHttpGet(paramDestacados);

        if (!articuloResp$) {
            return;
        }

        articuloResp$.subscribe({
            next: (res: ArticuloResp) => {
                this.articuloResp$ = res;

                const items = res.items ?? [];

                switch (destacado) {
                    case '1':
                        this.articulosDestac1.push(...items);
                        break;
                    case '2':
                        this.articulosDestac2.push(...items);
                        break;
                    case '3':
                        this.articulosDestac3.push(...items);
                        break;
                    case '4':
                        this.articulosDestac4.push(...items);
                        break;
                    case '5':
                        this.articulosDestac5.push(...items);
                        break;
                    case '6':
                        this.articulosDestac6.push(...items);
                        break;
                }
            },
            error: (err) => {
                this.handleError(err, false);
            },
            complete: () => {
                console.log('ARTICULOS- HTTP request completed.');
            }
        });
    }



    getArticuloById(id: string): Observable<ArticuloResp> {
        // Obtener el usuario desde el servicio de autenticación en lugar de directamente de localStorage
        const usuario: Usuario = this.authService.isLoggedIn()
            ? JSON.parse(this.storageService.getItem('usuario_model')!) : null;
        const almId: string = this.authService.isLoggedIn()
            ? usuario?.alm_id.toString()
            : environment.ALM_CATALOGO.toString();
        const cliId: string = this.authService.isLoggedIn()
            ? usuario?.cli_id.toString()
            : environment.CLI_CATALOGO.toString();

        const paramById: Parametro = {
            art_id: id,
            busca: '',
            alm_id: almId,
            cli_id: cliId,
            tar_id: (usuario === null || usuario === undefined || usuario?.tarc_id == null) ? '' : usuario.tarc_id.toString(),
            usuw_id: (usuario === null || usuario === undefined || usuario?.usuw_id == null) ? '' : usuario.usuw_id.toString(),
            pedcc_id: (usuario === null || usuario === undefined || usuario?.pedcc_id === null) ? '' : usuario.pedcc_id.toString(),
            pedcc_lista_id: (usuario === null || usuario === undefined || usuario?.pedcc_lista_id === null) ? '' : usuario.pedcc_lista_id.toString(),
            sector_id: '',
            sec_id: '',
            fam_id: '',
            novedad: false,
            consumo: false,
            top30: false,
            top7: false,
            oferta: false,
            marcapropia: false,
            ofc_id: '',
            destac_1: '',
            destac_2: '',
            destac_3: '',
            destac_4: '',
            destac_5: '',
            destac_6: '',
            espedido: false,
            eslista: false,
            clasifica: '',
            orden: '',
            offset: '',
            limit: '',
            fechaConsumoDesde: new Date(2000, 0, 1),
            fechaConsumoHasta: new Date(),
            consumoFechas: false
        };

        const articuloResp$ = this.articulosHttpGet(paramById);

        return articuloResp$.pipe(
            tap(res => {
                // this.articuloResp$ = res; // Asignar la respuesta correctamente
                this.isArticuloDetalle = true;
                this.articulo = res.items != undefined ? res.items![0] : undefined;
            }),
            catchError(err => {
                this.handleError(err, false); // Manejo de errores adecuado
                return EMPTY; // Devolver EMPTY si hay error
            }),
            finalize(() => console.log('ARTICULOS- HTTP request completed.'))
        );
    }


    /*
    * sustituye a getArticuloById en la llamada desde articulo-detalle.component "navegación a detalle del artículo"
    *  la otra no trae datos del pedido
    */
    getPedidoArticuloById(id: string): Observable<ArticuloResp> {
        const param: Parametro = this.nuevoParametro();
        param.alm_id = this.parametros.alm_id;
        param.pedcc_id = this.parametros.pedcc_id;
        param.cli_id = this.parametros.cli_id;
        param.espedido = true;
        param.limit = '1';
        param.art_id = id;

        const articuloResp$ = this.articulosHttpGet(param);
        return articuloResp$.pipe(
            tap(res => {
                // this.articuloResp$ = res; // Asignar la respuesta correctamente
            }),
            catchError(err => {
                this.handleError(err, true); // Manejo de errores adecuado
                return EMPTY; // Devolver EMPTY si hay error
            }),
            finalize(() => console.log('ARTICULOS- HTTP request completed.'))
        );
    }

    getSector(sectorId: number): Sector | undefined {
        return this.sectores.find(s => s.sector_id === sectorId);
    }
    getSeccion(seccionId: number): Seccion | undefined {
        return this.secciones.find(s => s.sec_id === seccionId);
    }
    getFamilia(famId: number): Familia | undefined {
        return this.familias.find(f => f.fam_id === famId);
    }
    getAllSectores(): Observable<SectorResp> {
        const estoyLogeado = this.authService.isLoggedIn();

        // Si no estamos logueados, retornamos un observable vacío
        if (!estoyLogeado && !environment.VER_PROD_LOGOUT) {
            return EMPTY;
        }

        const param: Parametro = this.nuevoParametro();
        const sectorResp$ = this.sectoresHttpGet(param);

        return sectorResp$.pipe(
            tap(res => {
                this.sectores = res.items ?? []; // Asignar directamente los sectores
            }),
            catchError((err: HttpErrorResponse) => {
                console.warn("El status es: " + err);
                if (err.status === 401) {
                    console.log("No autorizado (401). Redirigiendo al login...");

                } else {
                    console.error("Error HTTP:", err.status, err.message);
                }

                this.handleError(err, true);
                return EMPTY;
            }),
            finalize(() => console.log('SECTORES- HTTP request completed.')) // Acción al completar la petición
        );
    }


    getSecciones(): void {
        const estoyLogeado = this.authService.isLoggedIn();

        if (!estoyLogeado && !environment.VER_PROD_LOGOUT) {
            return;
        }

        const seccionResp$ = this.seccionesHttpGet(this.parametros);

        this.salvaParametros(this.paramUltSeccion);

        if (!seccionResp$) {
            return;
        }

        seccionResp$.subscribe({
            next: (res: SeccionResp) => {
                this.secciones = [];
                if (res.items) {
                    this.secciones.push(...res.items);
                }
            },
            error: (err) => {
                this.handleError(err, false);
            },
            complete: () => {
                if (
                    this.seccionActivo === undefined ||
                    this.secciones.indexOf(this.seccionActivo) === -1
                ) {
                    this.seccionActivo = undefined;
                }
                console.log('SECCIONES- HTTP request completed.');
            }
        });
    }

    getFamilias(): void {
        const estoyLogeado = this.authService.isLoggedIn();

        if (!estoyLogeado && !environment.VER_PROD_LOGOUT) {
            return; // No hace nada si no está logueado y no se permite ver familias
        }

        const familiaResp$ = this.familiasHttpGet(this.parametros);

        this.salvaParametros(this.paramUltSeccion);

        if (!familiaResp$) {
            return;
        }

        familiaResp$.subscribe({
            next: (res: FamiliaResp) => {
                this.familias = [];
                if (res.items) {
                    this.familias.push(...res.items);
                }
            },
            error: (err) => {
                this.handleError(err, false);
            },
            complete: () => {
                if (
                    this.familiaActivo === undefined ||
                    this.familias.indexOf(this.familiaActivo) === -1
                ) {
                    this.familiaActivo = undefined;
                    console.log('FAMILIAS- familiaActvo DESACTIVADA.');
                }
                console.log('FAMILIAS- HTTP request completed.');
            }
        });
    }

    getArtFiltros(): Observable<ArtFiltroResp> {
        const estoyLogeado = this.authService.isLoggedIn();

        if (!estoyLogeado && !environment.VER_PROD_LOGOUT) {
            return of(); // o throwError
        }

        this.salvaParametros(this.paramUltSeccion);

        return this.artFiltroHttpGet(this.parametros).pipe(
            catchError(err => {
                this.handleError(err, true);
                return throwError(() => err);
            }),
            finalize(() => console.log('FILTROS - HTTP request completed.'))
        );
    }




    articulosHttpGet(parametro: Parametro): Observable<ArticuloResp> {
        if (this.authService.isLoggedIn() && parametro.tar_id != null && parametro.tar_id !== '') {
            return this.coleccionHttpGet(this.SERVER_URL + '/articulostar', parametro);
        } else {
            return this.coleccionHttpGet(this.SERVER_URL + '/articulos', parametro);
        }
    }



    sectoresHttpGet(parametro: Parametro): Observable<SectorResp> {
        return this.coleccionHttpGet(this.SERVER_URL + '/sectores', parametro);
    }
    seccionesHttpGet(parametro: Parametro): Observable<SeccionResp> {
        return this.coleccionHttpGet(this.SERVER_URL + '/secciones', parametro);
    }
    familiasHttpGet(parametro: Parametro): Observable<FamiliaResp> {
        return this.coleccionHttpGet(this.SERVER_URL + '/familias', parametro);
    }
    artFiltroHttpGet(parametro: Parametro): Observable<ArtFiltroResp> {
        return this.coleccionHttpGet(this.SERVER_URL + '/artfiltros', parametro);
    }

    getArticuloImgs(artReferencia: string): Observable<any> {
        const headersCors = new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'POST, GET, OPTIONS',
            'Content-Type': 'application/json'
        });
        //const dominio = (new URL(this.SERVER_URL));
        return this.http.get(this.SERVER_URL + '/art/imagenes', {
            //headers: headersCors,
            params: {
                referencia: artReferencia,
                dominio: 'XXXXX'
            }
        });
    }

    coleccionHttpGet(url: string, parametro: Parametro): Observable<any> {
        const estoyLogeado = this.authService.isLoggedIn();
        if (!estoyLogeado && !environment.VER_PROD_LOGOUT) {
            return EMPTY;
        }
        const headersToken = new HttpHeaders({
            'Content-Type': 'application/json',
            // Authorization: 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN')
        });

        return this.http.get(url, {
            headers: headersToken,
            // headers: (environment.AUTH_TOKEN && estoyLogeado) ? headersToken : headersBasic,
            params: {
                busca: (environment.AGRUPACION == 'seccion' && url.indexOf('seccion') > 0) ? '' : parametro.busca,
                art_id: parametro.art_id,
                alm_id: parametro.alm_id,
                cli_id: parametro.cli_id,
                tar_id: parametro.tar_id,
                usuw_id: parametro.usuw_id,
                pedcc_id: parametro.pedcc_id,
                pedcc_lista_id: parametro.pedcc_lista_id,
                sector_id: parametro.sector_id,
                sec_id: parametro.sec_id,
                fam_id: parametro.fam_id,
                novedad: (parametro.novedad) ? parametro.novedad.toString() : '',
                consumo: (parametro.consumo) ? parametro.consumo.toString() : '',
                top30: (parametro.top30) ? parametro.top30.toString() : '',
                oferta: (parametro.oferta) ? parametro.oferta.toString() : '',
                marcapropia: (parametro.marcapropia) ? parametro.marcapropia.toString() : '',
                espedido: (parametro.espedido) ? parametro.espedido.toString() : '',
                eslista: (parametro.eslista) ? parametro.eslista.toString() : '',
                clasifica: parametro.clasifica,
                orden: parametro.orden,
                limit: parametro.limit,
                offset: parametro.offset,
                ofc_id: parametro.ofc_id,
                destac_1: parametro.destac_1,
                destac_2: parametro.destac_2,
                destac_3: parametro.destac_3,
                destac_4: parametro.destac_4,
                destac_5: parametro.destac_5,
                destac_6: parametro.destac_6,
                consumo_fechas: (parametro.consumoFechas) ? parametro.consumoFechas.toString() : '',
                fecha_consumo_desde: this.toYmd(parametro.fechaConsumoDesde),
                fecha_consumo_hasta: this.toYmd(parametro.fechaConsumoHasta)
            }
        });
    }
    private toYmd(d?: Date): string {
        if (!d) return '';
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
    }

    // private handleError(error: HttpErrorResponse) {
    //     this.estado = 'error';
    //     if (error.error instanceof ErrorEvent) {
    //         // A client-side or network error occurred. Handle it accordingly.
    //         console.error('An error occurred:', error.error.message);
    //     } else {
    //         // The backend returned an unsuccessful response code.
    //         // The response body may contain clues as to what went wrong,
    //         console.error(
    //             `Backend returned code ${error.status}, ` +
    //             `body was: ${error.error}`);
    //     }
    //     // return an observable with a user-facing error message
    //     return throwError(() => new Error('Something bad happened; please try again later.'));
    // }
    handleError(error: HttpErrorResponse, logout: boolean) {

        if (logout) {
            // console.clear();
            console.warn("STATUS: " + error.status);
        } else {
            // Verificamos si estamos en el navegador antes de usar ErrorEvent
            if (isPlatformBrowser(this.platformId)) {
                // console.clear();
                if (error.error instanceof ErrorEvent) {
                    // A client-side or network error occurred. Handle it accordingly.
                    console.error('An error occurred:', error.error.message);
                }
            } else {
                // console.clear();
                // Handle SSR error (en el servidor, no usamos ErrorEvent)
                console.error(
                    `Backend returned code ${error.status}, body was: ${error.error}`
                );
            }
        }

    }


    cambioConsulta(paramUlt: Parametro): boolean {
        if (this.parametros.busca !== paramUlt.busca
            || this.parametros.alm_id !== paramUlt.alm_id
            || this.parametros.sector_id !== paramUlt.sector_id
            || this.parametros.sec_id !== paramUlt.sec_id
            || this.parametros.fam_id !== paramUlt.fam_id
            || this.parametros.novedad !== paramUlt.novedad
            || this.parametros.consumo !== paramUlt.consumo
            || this.parametros.top30 !== paramUlt.top30
            || this.parametros.top7 !== paramUlt.top7
            || this.parametros.oferta !== paramUlt.oferta
            || this.parametros.marcapropia !== paramUlt.marcapropia
            || this.parametros.espedido !== paramUlt.espedido
            || this.parametros.eslista !== paramUlt.eslista
            || this.parametros.clasifica !== paramUlt.clasifica
            || this.parametros.ofc_id !== paramUlt.ofc_id
            || this.parametros.orden !== paramUlt.orden
            || this.parametros.destac_1 !== paramUlt.destac_1
            || this.parametros.destac_2 !== paramUlt.destac_2
            || this.parametros.destac_3 !== paramUlt.destac_3
            || this.parametros.destac_4 !== paramUlt.destac_4
            || this.parametros.destac_5 !== paramUlt.destac_5
            || this.parametros.destac_6 !== paramUlt.destac_6
            || !this.mismaFecha(this.parametros.fechaConsumoDesde, paramUlt.fechaConsumoDesde)
            || !this.mismaFecha(this.parametros.fechaConsumoHasta, paramUlt.fechaConsumoHasta)

        ) {
            return true;
        }
        return false;
    }
    private mismaFecha(a?: Date, b?: Date): boolean {
        if (!a && !b) return true;
        if (!a || !b) return false;

        return (
            a.getFullYear() === b.getFullYear() &&
            a.getMonth() === b.getMonth() &&
            a.getDate() === b.getDate()
        );
    }

    filtrosActivo(): boolean {
        if (this.parametros.busca !== ''
            || this.parametros.novedad
            || this.parametros.consumo
            || this.parametros.top30
            || this.parametros.top7
            || this.parametros.oferta
            || this.parametros.marcapropia
            || this.parametros.espedido
            || this.parametros.eslista
        ) {
            return true;
        }
        return false;
    }

    salvaParametros(paramUlt: Parametro) {

        paramUlt.busca = this.parametros.busca;
        paramUlt.alm_id = this.parametros.alm_id;
        paramUlt.cli_id = this.parametros.cli_id;
        paramUlt.tar_id = this.parametros.tar_id;
        paramUlt.pedcc_id = this.parametros.pedcc_id;
        paramUlt.pedcc_lista_id = this.parametros.pedcc_lista_id;
        paramUlt.sector_id = this.parametros.sector_id;
        paramUlt.sec_id = this.parametros.sec_id;
        paramUlt.fam_id = this.parametros.fam_id;
        paramUlt.novedad = this.parametros.novedad;
        paramUlt.consumo = this.parametros.consumo;
        paramUlt.top30 = this.parametros.top30;
        paramUlt.top7 = this.parametros.top7;
        paramUlt.oferta = this.parametros.oferta;
        paramUlt.marcapropia = this.parametros.marcapropia;
        paramUlt.espedido = this.parametros.espedido;
        paramUlt.eslista = this.parametros.eslista;
        paramUlt.clasifica = this.parametros.clasifica;
        paramUlt.ofc_id = this.parametros.ofc_id;
        paramUlt.orden = this.parametros.orden;
        paramUlt.destac_1 = this.parametros.destac_1;
        paramUlt.destac_2 = this.parametros.destac_2;
        paramUlt.destac_3 = this.parametros.destac_3;
        paramUlt.destac_4 = this.parametros.destac_4;
        paramUlt.destac_5 = this.parametros.destac_5;
        paramUlt.destac_6 = this.parametros.destac_6;
        paramUlt.fechaConsumoDesde = this.parametros.fechaConsumoDesde;
        paramUlt.fechaConsumoHasta = this.parametros.fechaConsumoHasta;
        paramUlt.consumoFechas = this.parametros.consumoFechas;
    }

    validarBusca(busca: string): boolean {
        const tieneMinimo3 = busca.length >= 3;
        const sinCaracteresEspeciales = /^[\p{L}\p{N}\s]+$/u.test(busca); // solo letras, números y espacios
        return (tieneMinimo3 && sinCaracteresEspeciales);
    }
    nuevoParametro(): Parametro {
        const usuario: Usuario = this.authService.isLoggedIn()
            ? JSON.parse(this.storageService.getItem('usuario_model')!) : undefined;
        const isLoggedIn = this.authService.isLoggedIn();
        const almId: string = isLoggedIn
            ? usuario?.alm_id.toString() : environment.ALM_CATALOGO.toString();
        const cliId: string = isLoggedIn
            ? usuario?.cli_id.toString() : environment.CLI_CATALOGO.toString();
        const tarId: string = (usuario === null || usuario === undefined || usuario?.tarc_id == null)
            ? '' : usuario.tarc_id.toString();
        const pedccId: string = (usuario === null || usuario === undefined || usuario?.pedcc_id === null)
            ? '' : usuario.pedcc_id.toString();
        const listaId: string = (usuario === null || usuario === undefined || usuario?.pedcc_lista_id === null)
            ? '' : usuario.pedcc_lista_id.toString();
        const usuwId: string = (usuario === null || usuario === undefined || usuario?.usuw_id == null)
            ? '' : usuario.usuw_id.toString();
        return {
            busca: '',
            alm_id: almId,
            art_id: '',
            cli_id: cliId,
            tar_id: tarId,
            usuw_id: usuwId,
            pedcc_id: pedccId,
            pedcc_lista_id: listaId,
            sector_id: '',
            sec_id: '',
            fam_id: '',
            novedad: false,
            consumo: false,
            top30: false,
            top7: false,
            oferta: false,
            marcapropia: false,
            espedido: false,
            eslista: false,
            clasifica: '',
            orden: 'DA',
            offset: '0',
            limit: '25',
            ofc_id: '',
            destac_1: '',
            destac_2: '',
            destac_3: '',
            destac_4: '',
            destac_5: '',
            destac_6: '',
            fechaConsumoDesde: (() => {
                const d = new Date();
                d.setFullYear(d.getFullYear() - 1);
                return d;
            })(),
            fechaConsumoHasta: new Date(),
            consumoFechas: false

        };
    }

    inicializaParametros(params: Parametro) {
        const usuario: Usuario = this.authService.isLoggedIn()
            ? JSON.parse(this.storageService.getItem('usuario_model')!) : undefined;
        const almId: string = (usuario === undefined || usuario.alm_id === null)
            ? (this.storageService.getItem('alm_id')) ? this.storageService.getItem('alm_id')! : '' : usuario.alm_id.toString();
        const cliId: string = (usuario === undefined || usuario.cli_id === null)
            ? '' : usuario.cli_id.toString();
        const tarId: string = (usuario === undefined || usuario.tarc_id === null)
            ? '' : usuario.tarc_id.toString();
        const pedccId: string = (usuario === undefined || usuario.pedcc_id === null)
            ? '' : usuario.pedcc_id.toString();
        const listaId: string = (usuario === undefined || usuario.pedcc_lista_id === null)
            ? '' : usuario.pedcc_lista_id.toString();
        const usuwId: string = (usuario === null || usuario === undefined || usuario?.usuw_id == null)
            ? '' : usuario.usuw_id.toString();
        params.busca = '';
        params.sector_id = '';
        params.sec_id = '';
        params.fam_id = '';
        params.alm_id = almId;
        params.cli_id = cliId;
        params.tar_id = tarId;
        params.usuw_id = usuwId;
        params.pedcc_id = pedccId;
        params.pedcc_lista_id = listaId;
        params.orden = 'DA';
        params.novedad = false;
        params.consumo = false;
        params.top30 = false;
        params.top7 = false;
        params.oferta = false;
        params.marcapropia = false;
        params.ofc_id = '';
        params.espedido = false;
        params.eslista = false;
        params.clasifica = '';
        params.destac_1 = '';
        params.destac_2 = '';
        params.destac_3 = '';
        params.destac_4 = '';
        params.destac_5 = '';
        params.destac_6 = '';
        params.orden = 'DA';
        params.offset = '0';
        params.limit = '25';
    }
    getTraduccionInformacionNutricional(str: string): Observable<any> {
        const apiUrl = 'https://es.libretranslate.com/translate';
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        const body = {
            q: str,
            source: 'auto',
            target: 'es',
            format: 'text',
            alternatives: 3,
            api_key: ''
        };

        return this.http.post(apiUrl, body, { headers });
    }
    getInformacionNutricional(art_id: number) {
        const url = this.SERVER_EAN_URL + "/" + art_id;
        const inforNutricionalResp$ = this.http.get(url);
        inforNutricionalResp$.subscribe(
            res => {
                if (res == null) {
                    this.response = res;
                    this.denominacionAlimento = '-';
                    this.nombreOperador = '-';
                    this.cantNeta = '-';
                    this.ingredientes = '-';
                    this.alergenos = '-';
                    this.valorEnergetico = '-';
                    this.energia = '-';
                    this.grasas = '-';
                    this.saturadas = '-';
                    this.hidratosCarbono = '-';
                    this.azucares = '-';
                    this.fibraAlimentaria = '-';
                    this.proteinas = '-';
                } else {
                    this.response = res;
                    this.denominacionAlimento = this.response.product.product_name && this.response.product.product_name !== "" ? this.response.product.product_name : "No disponible";
                    this.nombreOperador = this.response.product.brands && this.response.product.brands !== "" ? this.response.product.brands : "No disponible";
                    this.cantNeta = this.response.product.product_quantity ?? "No disponible";
                    this.ingredientes = this.response.product.ingredients_text && this.response.product.ingredients_text !== "" ? this.response.product.ingredients_text : "No disponible";
                    this.alergenos = this.response.product.allergens_from_ingredients && this.response.product.allergens_from_ingredients !== "" ? this.response.product.allergens_from_ingredients : "No disponible";
                    this.valorEnergetico = this.response.product.nutriments["energy-kcal_100g"] ?? "No disponible";
                    this.energia = this.response.product.nutriments.energy_100g ?? "No disponible";
                    this.grasas = this.response.product.nutriments.fat_100g ?? "-";
                    this.saturadas = this.response.product.nutriments["saturated-fat_100g"] ?? "-";
                    this.hidratosCarbono = this.response.product.nutriments.carbohydrates_100g ?? "-";
                    this.azucares = this.response.product.nutriments.sugars_100g ?? "-";
                    this.fibraAlimentaria = this.response.product.nutriments.fiber ?? "-";
                    this.proteinas = this.response.product.nutriments.proteins_100g ?? "-";

                    this.translateAllTexts();
                }
            },
            err => this.handleError(err, true),
            () => console.log('FILTROS- HTTP request completed.')
        );

    }
    translateAllTexts(): void {
        const textsToTranslate = [
            this.denominacionAlimento,
            this.nombreOperador,
            this.ingredientes,
            this.alergenos
        ];

        textsToTranslate.forEach((text, index) => {
            if (text !== "No disponible") {
                this.getTraduccionInformacionNutricional(text).subscribe({
                    next: (response) => {
                        const translatedText = response.translatedText;

                        // Asignar la traducción al valor correcto
                        switch (index) {
                            case 0: this.denominacionAlimento = translatedText; break;
                            case 1: this.nombreOperador = translatedText; break;
                            case 2: this.ingredientes = translatedText; break;
                            case 3: this.alergenos = translatedText; break;
                        }
                    },
                    error: (error) => {
                        console.error(`Error traduciendo "${text}":`, error);
                    }
                });
            }
        });
    }
}
/// Actualización 19.10.2021: agregar art_id
interface Parametro {
    busca: string;
    art_id: string;
    alm_id: string;
    cli_id: string;
    tar_id: string;
    usuw_id: string;
    pedcc_id: string;
    pedcc_lista_id: string;
    sector_id: string;
    sec_id: string;
    fam_id: string;
    novedad: boolean;
    consumo: boolean;
    top30: boolean;
    top7: boolean;
    oferta: boolean;
    marcapropia: boolean;
    ofc_id: string; // cambiar por int para meterla la oferta que viene de los banners
    destac_1: string; // 2
    destac_2: string; // 2
    destac_3: string; // 2
    destac_4: string; // 2
    destac_5: string; // 2
    destac_6: string; // 2
    fechaConsumoDesde?: Date;
    fechaConsumoHasta?: Date;
    consumoFechas: boolean;
    espedido: boolean;
    eslista: boolean;
    clasifica: string;
    orden: string;
    offset: string;
    limit: string;
}

interface Orden {
    valor: string;
    descripcion: string;
}
